import * as React from 'react';
import {useState, useEffect} from 'react';
import {History} from 'history';
import {IOrganization, logout as accountLogout} from '../../services/account';
import {injectIntl, InjectedIntlProps, defineMessages} from 'react-intl';
import {
    DASHBOARD_PATH,
    PROFILE_EDIT,
    HELP_PATH,
    CLIENT_CONTACT_PATH,
    LOGIN_PATH,
} from '../../constants';
import {IAvatar} from '../../services/documents';

import logoImage from '../../images/logo-3.png';
import {Link} from 'react-router-dom';
import ProfilePicture from './ProfilePicture';

export default injectIntl(
    (
        props: InjectedIntlProps & {
            history: History;
            organization: IOrganization | null | undefined;
            avatar: IAvatar | null | undefined;
        }
    ) => {
        const logout = () => {
            accountLogout();
            props.history.push(LOGIN_PATH);
        };

        const messages = defineMessages({
            account: {
                id: 'common.nav.account',
                defaultMessage: 'Account Profile',
            },
            contactUs: {
                id: 'common.nav.contactus',
                defaultMessage: 'Contact Us',
            },
            logout: {
                id: 'common.nav.logout',
                defaultMessage: 'Logout',
            },
            loading: {
                id: 'common.nav.loading',
                defaultMessage: 'Loading...',
            },
            toggle: {
                id: 'common.nav.toggle',
                defaultMessage: 'Toggle navigation',
            },
        });

        return (
            <header className="container-fluid topHeader">
                <nav className="navbar navbar-expand-lg navbar-dark">
                    <a className="navbar-brand" href={DASHBOARD_PATH}>
                        <img src={logoImage} width={150} />
                    </a>
                    <button
                        className="navbar-toggler"
                        type="button"
                        data-toggle="collapse"
                        data-target="#navbarSupportedContent"
                        aria-controls="navbarSupportedContent"
                        aria-expanded="false"
                        aria-label={props.intl.formatMessage(messages.toggle)}>
                        <span className="navbar-toggler-icon" />
                    </button>
                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul className="navbar-nav ml-auto">
                            <Link to={HELP_PATH} className="btn btn-link text-white">
                                <i className="fas fa-question-circle" />
                            </Link>
                            <li className="nav-item dropdown" style={{minWidth: 100}}>
                                <button
                                    className="nav-link dropdown-toggle btn btn-link pt-1"
                                    id="navbarDropdown"
                                    role="button"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false">
                                    {props.organization
                                        ? props.organization.orgName
                                        : props.intl.formatMessage(messages.loading)}
                                </button>
                                <div className="dropdown-menu" aria-labelledby="navbarDropdown">
                                    <Link className="dropdown-item" to={PROFILE_EDIT}>
                                        {props.intl.formatMessage(messages.account)}
                                    </Link>
                                    <Link className="dropdown-item" to={CLIENT_CONTACT_PATH}>
                                        {props.intl.formatMessage(messages.contactUs)}
                                    </Link>
                                    <a className="dropdown-item" href="#" onClick={logout}>
                                        {props.intl.formatMessage(messages.logout)}
                                    </a>
                                </div>
                            </li>
                            <ProfilePicture
                                className="d-none d-lg-block"
                                size={40}
                                avatar={props.avatar ? props.avatar.url : ''}
                            />
                        </ul>
                    </div>
                </nav>
            </header>
        );
    }
);



// WEBPACK FOOTER //
// ./src/client/shared/NavBar.tsx